import React, { useEffect, useState, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import Header from '../../../Header/Header'
import '../../Style/Addemp.css'
import './Vieweditdetails.css'
import { CiBadgeDollar, CiBank, CiCalendar, CiCreditCard1, CiCreditCard2, CiEdit, CiGrid41, CiLocationOn, CiMail, CiMemoPad, CiPhone, CiUser, CiViewList } from 'react-icons/ci'
import Sidebar from '../../../Sidebar/Sidebar'
import api_backend from '../../../../Config/api'
import { useSelector } from 'react-redux'
import userdemoimg from '../../../../Images/Pagesimg/userdemo'
import { format } from 'date-fns';
import { CiCircleAlert } from "react-icons/ci";
import { ViewUniqueiddetailsApi } from '../../../../Config/api'
const Vieweditdetails = () => {

  const employeeDetails1 = useSelector((state) => state.employees);
  const [employeeDetails, setEmployeeDetails] = useState(null);
  const [uniqueRowData, setUniqueRowData] = useState(null);
const [loadingUnique, setLoadingUnique] = useState(false);

  const navigate = useNavigate();


  useEffect(() => {
    if (employeeDetails1 && employeeDetails1.employees.length > 0) {
      setEmployeeDetails(employeeDetails1.employees[0]);
      
      // Fetch unique ID details when employee details are available
      const uniqueId = employeeDetails1.employees[0]?.staff_unique_id;
      if (uniqueId) {
        handleViewUnique(uniqueId);
      }
    }
  }, [employeeDetails1]);

  const editbasic = () => {
    navigate('/editbasicinfo')
  }

  const editpersonal = () => {
    navigate('/editpersonalinfo')
  }

  const editpayment = () => {
    navigate('/editpaymentinfo')
  }
  const handleaddemploye = () => {
    navigate('/addemployee')
  }

  const overview_view = () => {
    // navigate('/vieweditdetails', { state: { user_id } });
  }

  const salary_view = () => {
    navigate('/viewsalarydetails');
  }

  const handleViewUnique = async (uniqueId) => {
  if (!uniqueId) {
    console.log("No unique ID provided");
    return;
  }

  try {
    setLoadingUnique(true);
    console.log("Fetching unique ID details for:", uniqueId);

    const res = await ViewUniqueiddetailsApi(uniqueId);
    console.log("API Response:", res);

    const data = res?.data?.staff_details || res?.data;
    console.log("Extracted data:", data);

    setUniqueRowData(data);

  } catch (err) {
    console.error("Error fetching unique ID details:", err);
    // If API fails, still show the unique ID from employeeDetails
    setUniqueRowData({ staff_unique_id: uniqueId });
  } finally {
    setLoadingUnique(false);
  }
};
  
  
  return (
    <div className='index-container'>
      <Header />
      <div className='index-content-parent'>
        <div className='index-content'>
          <Sidebar />
          {employeeDetails ?
            (
              <>
                <div className='index-content-sub'>
                  <div className='index-main'>
                    <div className='addemp-subheader'>
                      <div className='addemp-subheader-sub'>
                        <div className='vieweditdet-subheader'>
                          <p> {employeeDetails && employeeDetails.register_details ? employeeDetails.register_details.name : "N/A"} </p>
                          <div className='vieweditdet-top-dropdown'>
                            <button onClick={handleaddemploye}>Add Employee</button>
                          </div>
                        </div>
                        <div className='addemp-subheader2'>
                          <div className="vieweditdet-stepper">
                            <div className="vieweditdet-step-indicator">
                              <span className='vieweditdet-redirect-link' onClick={overview_view}>
                                <div className='vieweditdet-step vieweditdet-selected'>
                                  Overview
                                </div>
                              </span>
                              <span className='vieweditdet-redirect-link2' onClick={salary_view}>
                                <div className='vieweditdet-step'>
                                  Salary Details
                                </div>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='addemp-line'></div>
                    <div className='addemp-maincontent-sub'>
                      <div className='addemp-form emp-edit'>
                        <div className="vieweditdet-left-side">
                          <div className='vieweditdet-left-side-sub'>
                            <div className='vieweditdet-card vieweditdet-full-card'>
                              <div className='vieweditdet-edit-icon' onClick={editbasic}>
                                <CiEdit />
                              </div>
                              <div className='vieweditdet-profile-edit'>
                                {employeeDetails.work_details.staff_pic ?
                                  (<img src={`${api_backend.BACKEND_API}${employeeDetails.work_details.staff_pic}`} alt="Employee" />
                                  )
                                  :
                                  (<img src={userdemoimg.demo_img} alt='img' />)

                                }
                              </div>
                              <div className='vieweditdet-leftside-name'>
                                <h4>{employeeDetails && employeeDetails.register_details ? employeeDetails.register_details.name : "N/A"}</h4>
                              </div>
                              <div className='vieweditdet-line'></div>
                              <div className='vieweditdet-leftcontent-view'>
                                <p className='vieweditdet-heading-p-left'>BASIC DETAILS:</p>
                                <span className='vieweditdet-details-left' >
                                  <div className='vieweditdet-details-left-icon'>
                                  <CiGrid41 />
                                  </div>
                                  <p style={{textOverflow:"ellipsis" ,overflow:"hidden",whiteSpace:"nowrap"}} >{employeeDetails && employeeDetails.work_location ? employeeDetails.work_location.company_name : "N/A"}</p>
                                </span>
                                <span className='vieweditdet-details-left'>
                                  <div className='vieweditdet-details-left-icon'>
                                    <CiViewList />
                                  </div>
                                  <p  style={{textOverflow:"ellipsis" ,overflow:"hidden",whiteSpace:"nowrap"}}>{employeeDetails ? employeeDetails.designation_name : "N/A"}</p>
                                </span>
                                <span className='vieweditdet-details-left'>
                                  <div className='vieweditdet-details-left-icon'>

                                    <CiMemoPad />

                                  </div>
                                  <p  style={{textOverflow:"ellipsis" ,overflow:"hidden",whiteSpace:"nowrap"}}>{employeeDetails ? employeeDetails.department_name : "N/A"}
                                  </p>
                                </span>
                                <span className='vieweditdet-details-left'>
                                  <div className='vieweditdet-details-left-icon'>
                                    <CiCalendar />
                                  </div>
                                  <p>
                                    DOJ(
                                    {employeeDetails && employeeDetails.work_details && employeeDetails.work_details.doj
                                      ? format(new Date(employeeDetails.work_details.doj), 'do MMMM yyyy')
                                      : 'N/A'}
                                    )
                                  </p>
                                   </span>
                                <span className='vieweditdet-details-left'>
                                  <div className='vieweditdet-details-left-icon'>
                                    <CiMail />
                                  </div>
                                  <p  style={{textOverflow:"ellipsis" ,overflow:"hidden",whiteSpace:"nowrap"}}>{employeeDetails && employeeDetails.work_details ? employeeDetails.work_details.work_email : "N/A"}</p>
                                </span>
                                <span className='vieweditdet-details-left'>
                                  <div className='vieweditdet-details-left-icon'>
                                    <CiPhone />
                                  </div>
                                  <p>{employeeDetails && employeeDetails.work_details ? employeeDetails.work_details.emergency_contact : "N/A"}</p>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="vieweditdet-right-side">
                          <div className='vieweditdet-card1'>
                            <div className='vieweditdet-edit-icon' onClick={editpersonal}>
                              <CiEdit />
                            </div>
                            <p className='vieweditdet-heading-p-left'>PERSONAL INFO:</p>
                            <span className='vieweditdet-details-left'>
                              <div className='vieweditdet-details-left-icon'>
                                <CiUser />
                              </div>
                              <p>{employeeDetails && employeeDetails.register_details ? employeeDetails.register_details.name : "N/A"}</p>
                            </span>
                            <span className='vieweditdet-details-left'>
                              <div className='vieweditdet-details-left-icon'>
                                <CiPhone />
                              </div>
                              <p>{employeeDetails && employeeDetails.register_details ? employeeDetails.register_details.phone : "N/A"}</p>
                            </span>
                            <span className='vieweditdet-details-left'>
                              <div className='vieweditdet-details-left-icon'>
                                <CiMail />
                              </div>
                              <p>{employeeDetails && employeeDetails.register_details ? employeeDetails.register_details.personal_email : "N/A"}</p>
                            </span>
                            <span className='vieweditdet-details-left'>
                              <div className='vieweditdet-details-left-icon'>
                                <CiLocationOn />
                              </div>
                              <p>{employeeDetails && employeeDetails.register_details ? employeeDetails.register_details.address_line1 : "N/A"}</p>
                            </span>
                            <span className='vieweditdet-details-left'>
                              <div className='vieweditdet-details-left-icon'>
                                <CiCircleAlert style={{color:"#007bff",fontSize:"20px"}} />
                              </div>
                              <p> 
                                {  `Unique ID: ${employeeDetails?.register_details?.staff_unique_id || "N/A"}`}
                              </p>
                            </span>
                          </div>
                          <div className='vieweditdet-card1'>
                            <div className='vieweditdet-edit-icon' onClick={editpayment}>
                              <CiEdit />
                            </div>
                            <p className='vieweditdet-heading-p-left'>PAYMENT:</p>
                            <span className='vieweditdet-details-left'>
                              <div className='vieweditdet-details-left-icon'>
                                <CiBank />
                              </div>
                              <p>Bank :  {employeeDetails && employeeDetails.payment_details ? employeeDetails.payment_details.bank_name : "N/A"}</p>
                            </span>
                            <span className='vieweditdet-details-left'>
                              <div className='vieweditdet-details-left-icon'>
                                <CiBadgeDollar />
                              </div>
                              <p>Account Number :  {employeeDetails && employeeDetails.payment_details ? employeeDetails.payment_details.account_num : "N/A"}</p>
                            </span>
                            <span className='vieweditdet-details-left'>
                              <div className='vieweditdet-details-left-icon'>
                                <CiCreditCard1 />
                              </div>
                              <p> Aadhar :  {employeeDetails && employeeDetails.payment_details ? employeeDetails.payment_details.aadhar_num : "N/A"}</p>
                            </span>
                            <span className='vieweditdet-details-left'>
                              <div className='vieweditdet-details-left-icon'>
                                <CiCreditCard2 />
                              </div>
                              <p> Pan : {employeeDetails && employeeDetails.payment_details ? employeeDetails.payment_details.pan_num : "N/A"}</p>
                            </span>                       
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )
            :
            (
              <></>
            )
          }

        </div>
      </div>
    </div>
  )
}

export default Vieweditdetails
